import { toast } from 'react-toastify';
import { default as qs } from 'query-string';

import { APP_ROUTES } from '../constants';
import { Event, Fleet } from '../interfaces';

export const copyEventURL = (currentEvent: Event, fleet: Fleet) => () => {
  const { protocol, host, pathname } = window.location;
  const qsValue = qs.stringify({ previewEventID: currentEvent?.id, fleet_id: fleet.uuid });

  const eventListUrl = `${protocol}//${host}${APP_ROUTES.portalList}?${qsValue}`;
  const basicUrl = `${protocol}//${host}${pathname}?${qsValue}`;

  navigator.clipboard.writeText(pathname === APP_ROUTES.matchesReviewGrid ? eventListUrl : basicUrl).then(() => {
    toast.info('Copied event URL to clipboard');
  });
};
